<template>
  <ul>
    <li><a href="https://www.instagram.com/fiestaplop/" target="_ig"><i class="fab fa-instagram"/></a></li>
    <li><a href="https://www.tiktok.com/@fiesta.plop" target="_tk"><i class="fa-brands fa-tiktok"/></a></li>
    <li><a href="https://www.facebook.com/fiestaplop" target="_fb"><i class="fab fa-facebook-f"/></a></li>
    <li><a href="https://open.spotify.com/playlist/0chZSO2GhNLUjfTOzcO5aC" target="_spotify"><i class="fab fa-spotify"/></a></li>
    <li><a href="mailto:fiesta@plop.com.ar"><i class="fa fa-envelope"/></a></li>
  </ul>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SocialLinks',
})
</script>